import React from "react"
import { graphql } from "gatsby"
import { withPrismicPreview } from "gatsby-plugin-prismic-previews"
import styled from "styled-components"
import Layout from "../components/layout"
import Seo from "../components/seo"
import { BlogPager, BlogCard, BlogCategoryNav } from "../components/blog"
import { LargeBanner } from "../components/slices"
import { StandardContainer } from "../components/common"

const BlogGrid = styled(StandardContainer)`
  display: grid;
  grid-gap: 4rem;
  margin-top: 5rem;
  margin-bottom: 5rem;

  /* Medium */
  @media ${(props) => props.theme.breakpoints.medium} {
    grid-template-columns: repeat(2, 1fr);
  }

  /* Large */
  @media ${(props) => props.theme.breakpoints.large} {
    grid-template-columns: repeat(3, 1fr);
  }
`

const BlogCategory = ({ data, pageContext }) => {
  const { illustration, title, meta_title, meta_description, keywords } =
    data?.category?.data

  const articles = data?.posts?.nodes || []

  const keywordArray = keywords ? keywords.split(",") : []
  return (
    <Layout>
      <Seo
        title={meta_title && meta_title?.text}
        description={meta_description && meta_description?.text}
        keywords={keywordArray}
      />
      <LargeBanner
        illustration={illustration}
        banner_title={title}
        banner_subtitle={{ title: null }}
        background_color="#5EC7D0"
        short
      />
      <BlogCategoryNav />
      <BlogGrid $wrappedStandard id="blogGrid">
        {articles?.map((item, index) => (
          <BlogCard
            key={`blogCategoryCard-${index}`}
            {...item}
            {...item?.data}
          />
        ))}
      </BlogGrid>
      <BlogPager pageContext={pageContext} />
    </Layout>
  )
}

export default withPrismicPreview(BlogCategory)

export const PageQuery = graphql`
  query ($uid: String!, $skip: Int!, $limit: Int!) {
    category: prismicBlogCategory(uid: { eq: $uid }) {
      _previewable
      data {
        title {
          text
        }
        meta_title {
          text
        }
        meta_description {
          text
        }
        keywords
        illustration {
          url
          alt
        }
      }
    }
    posts: allPrismicBlogPost(
      sort: { data: { post_date: DESC } }
      skip: $skip
      limit: $limit
      filter: { data: { category: { uid: { eq: $uid } } } }
    ) {
      nodes {
        uid
        id
        url
        first_publication_date(formatString: "d MMM Y")
        data {
          featured_video_url
          title {
            text
          }
          excerpt {
            html
          }
          category {
            document {
              ... on PrismicBlogCategory {
                data {
                  title {
                    text
                  }
                  category_color
                }
              }
            }
          }
        }
      }
    }
  }
`
